module.exports = __webpack_public_path__ + "static/media/ge.b1776c7a.svg";